<template>
  <div>
    <div class="d-flex flex-row">
      <p class="text-2xl mb-2">Airflow</p>
      <v-spacer></v-spacer>
      <dev-menu></dev-menu>
    </div>
    <v-card class="mx-auto">
      <v-card-title class="text-h6 font-weight-regular justify-space-between">
        <span>{{ currentTitle }}</span>
        <v-avatar color="primary" size="24" v-text="step"></v-avatar>
      </v-card-title>
      <v-card-text v-if="step == 1">
        <v-row class="px-5">
          <p>
            Une fois un workflow sélectionné, vous pourrez cliquer sur le bouton
            "Status" pour en savoir plus suir lui.
            <br />
            Les workflow en bleu sont ceux permettant d'être lancé via cette
            interface (bouton "Next")
          </p>
        </v-row>
      </v-card-text>
      <v-window v-model="step">
        <v-window-item :value="1">
          <v-card-text>
            <v-data-table
              v-model="selected"
              :headers="headers"
              :items="filteredItems"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              single-select
              item-key="dag_id"
              show-select
              class="elevation-1"
              :items-per-page.sync="itemsPerPage"
              :options.sync="options"
              :server-items-length="totalItems"
              :loading="loading"
              :footer-props="{
                'items-per-page-options': [5, 10, 25, 50, 100, -1],
                'items-per-page-text': 'Lignes par page :'
              }"
            >
              <template v-slot:top>
                <div class="d-flex flex-row mb-6">
                  <v-text-field
                    v-model="searchStr"
                    append-icon="mdi-magnify"
                    label="Search"
                    @input="search"
                    single-line
                    hide-details
                    class="ma-2"
                  ></v-text-field>
                  <v-spacer></v-spacer>
                  <v-btn
                    :disabled="!selected.length"
                    v-on:click="showDagInfos"
                    color="primary"
                    elevation="4"
                    class="ma-2"
                  >
                    <v-icon>
                      {{ icons.mdiStateMachine }}
                    </v-icon>
                    <div class="mx-2">Status</div>
                  </v-btn>
                </div>
              </template>
              <template v-slot:item.dag_id="{ item }">
                <div
                  :class="
                    dagsHandled.includes(item.dag_id)
                      ? `dag-handled`
                      : `dag-not-handled`
                  "
                  class="time-cell"
                  style="text-align: left"
                >
                  {{ item.dag_id }}
                </div>
              </template>
              <template v-slot:item.next_dagrun="{ item }">
                <div class="time-cell" style="text-align: right">
                  {{ truncate(item.next_dagrun, 16, "") }}
                </div>
              </template>
              <template v-slot:item.last_run_state="{ item }">
                <v-chip
                  :class="getColor(item.last_run_state)"
                  dark
                  class="mr-3"
                >
                  {{ item.last_run_state }}
                </v-chip>
              </template>
            </v-data-table>
          </v-card-text>
        </v-window-item>

        <v-window-item :value="2">
          <partner-get-and-store-daily
            v-if="
              [
                'partner_get_and_store_daily_dag',
                'test_with_params_dag',
              ].includes(selectedDagId)
            "
            :partnersList="partnersList"
            @onUpdate="updateDagParams"
          ></partner-get-and-store-daily>
          <ga-get-and-store
            v-if="
              ['ga_get_and_store_manual_dag', 'test_with_params_dag'].includes(
                selectedDagId
              )
            "
            :siteList="siteList"
            @onUpdate="updateDagParams"
          ></ga-get-and-store>
        </v-window-item>

        <v-window-item :value="3">
          <div class="pa-4 text-center">
            <h3 class="text-h6 font-weight-light mb-2">
              Lancer le workflow <b>{{ selectedDagId }}</b>
            </h3>
            <div
              v-if="dagParamsTexts.length > 0"
              class="text-h5 font-weight-light mb-2"
            >
              avec les paramètres suivant :
            </div>
            <v-row v-if="dagParamsTexts.length > 0">
              <v-col cols="2"> </v-col>
              <v-col cols="8" class="text-left">
                <div v-if="!paramsDevVersion">
                  <ul>
                    <li v-for="(text, i) in dagParamsTexts">{{ text }}</li>
                  </ul>
                </div>
                <div v-else>
                  <ul v-show="Object.keys(dagParams).length">
                    <li v-for="(value, propertyName) in dagParams">
                      {{ propertyName }} : {{ value }}
                    </li>
                  </ul>
                  <div
                    v-if="dagParamsCommand != ''"
                    class="text-caption text-grey pt-2"
                  >
                    {{ dagParamsCommand }}
                  </div>
                  <div v-else class="text-caption text-grey">
                    Aucun paramètre nécessaire à passer car ce sont ceux par
                    défaut.
                  </div>
                </div>

                <v-switch
                  v-model="paramsDevVersion"
                  label="Version pour dévelopeur"
                  inset
                ></v-switch>
              </v-col>
              <v-col cols="2"> </v-col>
            </v-row>
            <v-row>
              <v-col cols="3"> </v-col>
              <v-col cols="6" class="text-left"> </v-col>
              <v-col cols="3"> </v-col>
            </v-row>
            <v-btn
              color="primary"
              class="mt-4"
              @click="runDag"
              :disabled="dagParamsErrors.length !== 0"
            >
              Lancer le workflow
            </v-btn>
          </div>
        </v-window-item>
      </v-window>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn v-if="btnBackShow" variant="text" @click="step--"> Back </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          v-if="btnNextShow"
          color="primary"
          variant="flat"
          @click="gotoNextStep"
        >
          Next
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import axios from "@axios";
import store from "@/store";
import { truncate, formatTime } from "@/utils/formatting";
import {
  mdiStateMachine,
  mdiTextBoxMultipleOutline,
} from "@mdi/js";
import PartnerGetAndStoreDaily from "@/views/pages/admin/includes/airflow/PartnerGetAndStoreDaily";
import GaGetAndStore from "@/views/pages/admin/includes/airflow/GaGetAndStore";
import DevMenu from "@/views/menus/DevMenu.vue";

export default {
  name: "Airflow",
  components: { DevMenu, PartnerGetAndStoreDaily, GaGetAndStore },
  data() {
    return {
      partnersList: [],
      siteList: [],
      step: 1,
      paramsDevVersion: false,
      searchStr: "",
      selected: [],
      itemsPerPage: 10,
      totalItems: 0,
      options: {},
      loading: false,
      sortBy: "dag_id",
      sortDesc: false,
      getDagsTimeout: null,
      items: [],
      filteredItems: [],
      dagsHandled: [
        "test_with_params_dag",
        "partner_get_and_store_daily_dag",
        "ga_get_and_store_manual_dag",
      ],
      dagsDescription: {
        test_with_params_dag:
          "Workflow de test permettant de lancer un workflow avec des paramètres sans conséquences",
        partner_get_and_store_daily_dag:
          "Workflow Programmatique chargé de récupérer les données de partenaire(s).",
        partner_gmail_credentials_check_dag:
          "Workflow Programmatique pour essayer de refresh les credentials de gmail quand c'est possible",
        ga_get_and_store_manual_dag:
          "Workflow chargé de récupérer les sessions et pages vues des sites via l'API Google Analytics.",
        adn_audience_backfill_plan_dag:
          "Construit un plan en lecture seule depuis la page Backfill Audience / adn_post.",
        adn_audience_backfill_execute_dag:
          "Exécute un plan approuvé depuis la page Backfill Audience / adn_post.",
      },
      dagParams: {},
      dagParamsErrors: [],
      dagParamsTexts: [],
      dagParamsCommand: "",
      headers: [
        {
          text: "Workflow Identifier",
          align: "start",
          sortable: true,
          value: "dag_id",
        },
        {
          text: "Description",
          align: "start",
          sortable: false,
          value: "description",
        },
        {
          text: "Description de la périodicité",
          align: "start",
          sortable: false,
          value: "timetable_description",
        },
        {
          text: "Has errors",
          align: "start",
          sortable: false,
          value: "has_import_errors",
        },
        {
          text: "is_active",
          align: "start",
          sortable: false,
          value: "is_active",
        },
        {
          text: "Run state",
          align: "start",
          sortable: false,
          value: "last_run_state",
        },
      ],
      icons: {
        mdiStateMachine,
        mdiTextBoxMultipleOutline,
      },
    };
  },
  async mounted() {
    this.partnersList = await this.$store.dispatch("premium/getPartnersList");
    this.siteList = await this.$store.dispatch("common/getSiteList");
    await this.fetchServerItems();
  },
  methods: {
    async runDag() {
      const payload = {
        dag_id: this.selected[0].dag_id,
        dag_params: this.dagParams,
      };
      const response = await axios.post("/airflow/dag/run", payload);
      if (response.status === 200) {
        await store.dispatch("app/setSnackBar", {
          show: true,
          text: `Workflow ${this.selectedDagId} lancé avec succès !`,
          color: "success",
          timeout: 5000,
        });
        this.step = 1;
      } else {
        await store.dispatch("app/setSnackBar", {
          show: true,
          text: `Erreur(s): ${JSON.stringify(error.response.data, null, 2)}`,
          color: "warning",
          timeout: 5000,
        });
      }
    },
    updateDagParams(dagParamsInfos) {
      this.dagParams = dagParamsInfos.params;
      this.dagParamsErrors = dagParamsInfos.errors;
      this.dagParamsTexts = dagParamsInfos.texts;
      this.dagParamsCommand = dagParamsInfos.command;
    },
    askGetDagList() {
      if (this.getDagsTimeout) {
        clearTimeout(this.getDagsTimeout);
        this.getDagsTimeout = null;
      }
      setTimeout(() => {
        this.getDagList();
      }, 500);
    },
    async fetchServerItems() {
      this.loading = true;
      const { page = 1, itemsPerPage = 10, sortBy = [], sortDesc = [] } = this.options;
      const limit = itemsPerPage > 0 ? itemsPerPage : 0;
      const offset = itemsPerPage > 0 ? (page - 1) * itemsPerPage : 0;
      
      let orderBy = "dag_id";
      if (sortBy.length > 0) {
        orderBy = (sortDesc[0] ? "-" : "") + sortBy[0];
      }

      const params = {
        offset,
        limit,
        order_by: orderBy,
      };

      if (this.searchStr) {
        params.dag_id_pattern = this.searchStr;
      }

      try {
        const { items, total } = await this.$store.dispatch("common/collectAirflowDagList", params);
        this.totalItems = total;
        const enrichedItems = (items || []).map((item) => ({
          ...item,
          description: item.dag_id in this.dagsDescription ? this.dagsDescription[item.dag_id] : "",
        }));
        this.items = enrichedItems;
        this.filteredItems = enrichedItems;
      } catch (e) {
        console.error("Error fetching DAG list:", e);
      } finally {
        this.loading = false;
      }
    },
    async getDagList() {
      await this.fetchServerItems();
    },
    search() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
        this.searchTimeout = null;
      }
      this.searchTimeout = setTimeout(() => {
        if (this.options.page !== 1) {
          this.options.page = 1;
        } else {
          this.fetchServerItems();
        }
      }, 500);
    },
    setFilteredItems() {
      // Server-side filtered items are set directly in fetchServerItems
    },
    async showDagInfos() {
      if (!this.selected.length) return;
      await store.dispatch("app/setDialog", {
        show: true,
        title: "Dag Infos",
        text: "Dag Infos",
        code: JSON.stringify(this.selected[0], null, 2),
      });
    },
    async gotoNextStep() {
      if (
        this.step === 1 &&
        (this.selected.length === 0 ||
          !this.dagsHandled.includes(this.selected[0].dag_id))
      ) {
        await store.dispatch("app/setSnackBar", {
          show: true,
          text: "Erreur: Il faut sélectionner un workflow pris en charge (en bleu) pour continuer.",
          color: "warning",
          timeout: 3000,
        });
        return;
      }
      if (
        this.step === 1 &&
        this.selected.length === 1 &&
        this.selected[0].last_run_state === "running"
      ) {
        await store.dispatch("app/setSnackBar", {
          show: true,
          text: "Erreur: Ce workflow est en cours de traitement. Veuillez attendre qu'il se termine avant de le relancer.",
          color: "warning",
          timeout: 3000,
        });
        return;
      }
      if (this.step === 2 && this.dagParamsErrors.length > 0) {
        await store.dispatch("app/setSnackBar", {
          show: true,
          text: `Erreur(s): ${this.dagParamsErrors.join(", ")}`,
          color: "warning",
          timeout: 3000,
        });
        return;
      }
      this.step += 1;
    },
    getColor(last_run_state) {
      let colors = {
        running: "blue",
        success: "green",
        failed: "red",
        undefined: "black",
      };
      return colors[last_run_state];
    },
  },
  computed: {
    dagList() {
      return this.$store.getters["common/getAirflowDagList"];
    },
    selectedDagId() {
      return this.selected.length > 0
        ? this.selected[0].dag_id
        : "partner_get_and_store_daily_dag"; // null;
    },
    btnNextShow() {
      return this.step < 3;
    },
    btnBackShow() {
      return this.step > 1;
    },
    currentTitle() {
      switch (this.step) {
        case 1:
          return "Sélectionner un workflow";
        case 2:
          return `Configurer le workflow ${this.selected[0].dag_id}`;
        case 3:
          return "Récapitulatif et lancement";
        default:
          return "Default title";
      }
    },
    truncate() {
      return truncate;
    },
    formatTime() {
      return formatTime;
    },
  },
  watch: {
    options: {
      handler() {
        this.fetchServerItems();
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
div.dag-not-handled {
  color: gray;
}
div.dag-handled {
  color: blue;
}

.v-chip.v-chip--no-color.blue {
  background-color: blue;
}
.v-chip.v-chip--no-color.green {
  background-color: green;
}
.v-chip.v-chip--no-color.orange {
  background-color: orange;
}
.v-chip.v-chip--no-color.red {
  background-color: red;
}
.v-chip.v-chip--no-color.black {
  background-color: black;
}
</style>
